import React from 'react';

import { UserContext, RootStoreContext } from '../../context';


export default (Component) => class extends React.Component {
  render() {
    return (
      <UserContext.Consumer>
        {(value) => (
          <RootStoreContext.Consumer>
            {(rootStore) => (
              <Component rootStore={rootStore} user={value} {...this.props} />
            )}
          </RootStoreContext.Consumer>
        )}
      </UserContext.Consumer>
    );
  }
};
